<script setup lang="ts">
/**
 * The template's "Sign up with Google" pill: outline button, full width, the
 * Google mark inline before the label. Shared by the login, registration and
 * quick-signup forms so the OAuth entry point looks the same everywhere.
 *
 * Both label copies carry the icon so the label-swap hover keeps it in place.
 */
defineProps<{
  label: string
  disabled?: boolean
}>()

const emit = defineEmits<{
  click: []
}>()

const button = ref<HTMLButtonElement>()

/*
 * On a phone the server-rendered button shows seconds before the app hydrates,
 * and a tap in that gap had no handler: users had to tap twice. The inline
 * `onclick` below works without Vue and only marks the tap; once mounted, a
 * marked tap is replayed so sign-in starts without a second tap.
 */
onMounted(() => {
  const el = button.value
  if (el?.dataset.earlyTap) {
    delete el.dataset.earlyTap
    emit('click')
  }
})
</script>

<template>
  <button
    ref="button"
    type="button"
    class="btn btn-outline w-full"
    :class="{ 'cursor-not-allowed opacity-60': disabled }"
    :disabled="disabled"
    onclick="this.dataset.earlyTap = '1'"
    @click="$emit('click')"
  >
    <span class="flex items-center gap-2">
      <img src="/sofax/google-icon.svg" alt="" aria-hidden="true" width="27" height="28" class="inline-block">
      {{ label }}
    </span>
    <span class="flex items-center gap-2" aria-hidden="true">
      <img src="/sofax/google-icon.svg" alt="" aria-hidden="true" width="27" height="28" class="inline-block">
      {{ label }}
    </span>
  </button>
</template>
